import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "GroupsSharedFoldersStore"*/ './lazyIndex'),
    { name: 'GroupsSharedFoldersStore' }
);
export const lazyGetGroupFolderName: LazyImport<
    typeof lazyIndex.getGroupFolderName,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupFolderName);
export const lazyHasUserCreatedFolders: LazyImport<
    typeof lazyIndex.hasUserCreatedFolders,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.hasUserCreatedFolders);
export const lazyGetGroupFolderChildFolderIds: LazyImport<
    typeof lazyIndex.getGroupFolderChildFolderIds,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupFolderChildFolderIds);
export const lazyGetGroupFolderId: LazyImport<
    typeof lazyIndex.getGroupFolderId,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupFolderId);
export const lazyGetGroupFolderTreeLoadingState: LazyImport<
    typeof lazyIndex.getGroupFolderTreeLoadingState,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupFolderTreeLoadingState);
export const lazyGetGroupTotalUsage: LazyImport<
    typeof lazyIndex.getGroupTotalUsage,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupTotalUsage);
